export const loginConstants = {
  REGISTER: "USERS_REGISTER",
  LOGIN: "USERS_LOGIN",
  MODULE_LOGIN: "MODULE_LOGIN",
  LOGOUT: "USERS_LOGOUT",
  EMAIL_VERIFIED: "EMAIL_VERIFIED",
  successful_login: "Login successful.",
  invalid_credentials: "Invalid credentials provided. Please try again.",
  ISLOGIN_FROM_COMPT_REG_FORM: "ISLOGIN_FROM_COMPT_REG_FORM",
  SHOW_LOGIN_MODAL: "SHOW_LOGIN_MODAL",
  LOGOUT: "LOGOUT",

  PASSWORD_RESET_REQUEST: "PASSWORD_RESET_REQUEST",
  PASSWORD_RESET_SUCCESS: "PASSWORD_RESET_SUCCESS",
  PASSWORD_RESET_FAILURE: "PASSWORD_RESET_FAILURE",

  // Messages
  passwordResetSuccess: "Password reset successful.",
  passwordResetFailure: "Password reset failed. Please try again.",
  UNDER_REVIEW: "UNDER_REVIEW",

  SPINNER_ACTIVATE: "LOGIN_SPINNER_ACTIVATE",
  SPINNER_DEACTIVATE: "LOGIN_SPINNER_DEACTIVATE",
};

export const userConstants = {
  USERS_DATA: "USERS_DATA",
  OPEN_MODAL: "OPEN_MODAL",
  OPEN_APPREJ_MODAL: "OPEN_APPREJ_MODAL",
  APPROVALS_DATA: "APPROVALS_DATA",
  USER_DATA: "USER_DATA",
  APPROVAL_USER_DATA: "APPROVAL_USER_DATA",
  USER_APPROVAL_VIEW_MODAL: "USER_APPROVAL_VIEW_MODAL",
  IS_UPDATED: "IS_UPDATED",
  USER_SPORTS: "USER_SPORTS",
  SET_QUALIFICATION_FORM_STATE: "SET_QUALIFICATION_FORM_STATE",
};

export const adminUserConstants = {
  ADMIN_USERS_DATA: "ADMIN_USERS_DATA",
  OPEN_MODAL: "OPEN_MODAL",
  ADD_ADMIN_USER: "ADD_ADMIN_USER",
  UPDATE_ADMIN_USER: "UPDATE_ADMIN_USER",
  DELETE_ADMIN_USER: "DELETE_ADMIN_USER",
  GET_ADMIN_USER_BY_ID: "GET_ADMIN_USER_BY_ID",
};
